module.exports = __webpack_public_path__ + "img/BRCA2_Myofibroblasts.526bd83e.png";